import KaistoreHawkHelper from 'kaistore-hawk-helper/lib';
import Account from '../account';
import { PaymentDetail } from 'kaistore-post-messenger/src/models';
import {
  RequestInstalledAppsCommand,
  RequestPaymentProfileCommand,
  RequestPaymentCommand
} from 'kaistore-post-messenger/src/commands';
import { MessageSender } from 'web-message-helper';
import AppStore from '../app-store';

class PaymentHelper {
  constructor() {
    this._apiPrefix = deviceInfos.get('apps.serviceCenterUrl');
    this.noProvider = false;

    // Change the value at all paymentHelper's instances.
    window.addEventListener('kaypay:no-provider', () => {
      this.noProvider = true;
    });
  }

  // Use 'profile' to get price & currency from KaiPay.
  // Use 'payment' to enter KaiPay payment process.
  request(type = 'profile', options = new Object()) {
    options.type = type;

    if (type === 'payment' && !options.detail) {
      console.error('No detail.id & detail.name in options object.');
    } else if (options.detail) {
      // Build up inter app communication with KaiPay.
      options.detail.connectKeyword = 'kaipay-to-kaistore';
    }

    if (type === 'payment') {
      Account.onLoginLocked = true;
      return this.pay(options.detail);
    } else if (type === 'profile') {
      return this.getProfile();
    } else {
      console.error('Unkown payment activity type');
      return false;
    }
  }

  sendHttpRequest(url) {
    let requester = KaistoreHawkHelper.getRequester({
      serverTimeOffset: window.serverTimeOffset,
      deviceInfos: window.deviceInfos,
      setDeviceInfo: true,
      useCustomConnectionType: true
    });

    return new Promise((resolve, reject) => {
      requester
        .send({
          url: url,
          method: 'GET'
        })
        .then(
          response => {
            resolve(JSON.parse(response));
          },
          error => {
            reject(error);
          }
        );
    });
  }

  getAllPurchased() {
    let url = this._apiPrefix + '/products?purchased=true';

    return new Promise((resolve, reject) => {
      this.sendHttpRequest(url).then(
        result => resolve(result),
        error => {
          error.url = url;
          reject(error);
        }
      );
    });
  }

  getPurchasedByProductId(productId) {
    let url = this._apiPrefix + '/products/' + productId + '?purchased=true';

    return new Promise((resolve, reject) => {
      this.sendHttpRequest(url)
        .then(result => resolve(result))
        .catch(error => {
          error.url = url;
          reject(error);
        });
    });
  }

  getReceiptsByTransactionId(transactionId) {
    let url = this._apiPrefix + '/purchases/' + transactionId + '/receipt';

    return new Promise((resolve, reject) => {
      this.sendHttpRequest(url).then(
        result => resolve(result),
        error => {
          error.url = url;
          reject(error);
        }
      );
    });
  }

  getProfile() {
    return new Promise((resolve, reject) => {
      MessageSender.send(
        new RequestPaymentProfileCommand(),
        (success, detail) => {
          if (success) {
            const { price, currency } = detail;
            detail.unitPrice = currency + ' $' + price;
            resolve(detail);
          } else {
            // 1. Show dialog with no price info @ Appspanel.js
            // 2. Store without paid apps @ applications.js
            console.warn('Failed to fetch price: ', detail);
            reject(detail);
          }
        }
      );
    });
  }

  pay(detail) {
    return new Promise((resolve, reject) => {
      const { id, name } = detail;
      const command = new RequestPaymentCommand({
        detail: new PaymentDetail({
          id: id,
          name: name
        })
      });
      MessageSender.send(command, (success, detail) => {
        const { receipt, error } = detail;
        if (success) {
          resolve(receipt);
        } else {
          reject('Failed payment process: ', error);
        }
      });
    });
  }

  isProductPurchased(productId) {
    return new Promise((resolve, reject) => {
      this.getPurchasedByProductId(productId)
        .then(product => {
          if (product && product.transaction_id) {
            resolve();
          } else {
            reject();
          }
        })
        .catch(() => {
          reject();
        });
    });
  }

  isSupportPrice(version) {
    // KaiPay supports to get price after version 2.3.1+
    const SUPPORT_VERSION = {
      major: 2,
      minor: 3,
      build: 1
    };
    const versionAry = version.replace(/[^0-9^.]/g, '').split('.');
    const major = parseInt(versionAry[0], 10);
    const minor = parseInt(versionAry[1], 10);
    const build = parseInt(versionAry[2], 10);

    if (major > SUPPORT_VERSION['major']) {
      return true;
    } else if (
      major === SUPPORT_VERSION['major'] &&
      minor > SUPPORT_VERSION['minor']
    ) {
      return true;
    } else if (
      major === SUPPORT_VERSION['major'] &&
      minor === SUPPORT_VERSION['minor'] &&
      build >= SUPPORT_VERSION['build']
    ) {
      return true;
    }
    return false;
  }

  getKaipayVersion() {
    const KAIPAY_ID = 'UgW01f5JflryQMM4H7SF';
    const apps = Object.values(AppStore.installedApps);
    const kaipay = apps.find(app => {
      return app.id === KAIPAY_ID;
    });
    if (kaipay && kaipay.mozAPP.manifest && kaipay.mozAPP.manifest.version) {
      return kaipay.mozAPP.manifest.version;
    }
    return null;
  }

  _getAppId(manifestURL) {
    const partitions = manifestURL.split('/');
    const len = partitions.length;

    return partitions[len - 1];
  }
}
export default PaymentHelper;



/** WEBPACK FOOTER **
 ** ./src/helper/payment-helper.js
 **/